//simple functions
import { can_display, trigger_text_editor, trigger_sort, strip_html, start_loading, end_loading } from './../function/common.js';
import { notification } from './../function/notification.js';
import { api } from './../function/api.js';
import DOMPurify from 'dompurify'; 

//classes
import { Map, User, Media, Editor, TripManager, TripAttributes, ExpenseManager, TripOrganize } from './../classes.js';

//runtime systems
import { register_marker, set_button_state, clean_map_view } from './../runtime/registerMap.js';

//elements
import { text__element } from './../element/text.js';
import { event__element } from './../element/event.js';
import { image__element } from './../element/image.js';
import { youtube__element } from './../element/youtube.js';
import { purchase_summary__element } from './../element/purchase_summary.js';
import { trip_summary__element } from './../element/trip_summary.js';
import { calendar__element } from './../element/calendar.js';
import { trip_block__element } from './../element/trip_block.js';
import { trip_title__element } from './../element/trip_title.js';

//marker icons
import * as icon from './../vars/icons.js';


export class cTrip {
	
	constructor() {
		/*
		
		/////ITINERARY
		<span class="toolbar_additional_options material-symbols-outlined">
			arrow_right
		</span>
		
		<ul class="trip_toolbar--sub">
			<li data-toolbar="duplicate" data-media="true">With Media</li>
			<li data-toolbar="duplicate" data-media="false">Without Media</li>
		</ul>
		
		<li data-toolbar="email-pdf">
			<span class="material-symbols-outlined">
				mail
			</span>
			<span>Email as PDF</span>
		</li>
		<li class="border-bottom" data-toolbar="download-pdf">
			<span class="material-symbols-outlined">
				download
			</span>
			<span>Download PDF</span>
		</li>
		
		
		////////TOOLS
		<li data-toolbar="">
			<span class="material-symbols-outlined">
				spellcheck
			</span>
			<span>Spell Check</span>
		</li>
		*/
		
		this.toolbar = `
			<div id="mobile_toolbar_trigger">
				<span class="material-symbols-outlined">menu</span>
				<span>File</span>
				<span class="material-symbols-outlined">arrow_drop_down</span>
			</div>
			<ul class="trip_toolbar--main">
				<li>
					<span class="trip_toolbar--trigger active_listener">Itinerary</span>
					
					<ul class="trip_toolbar--sub active_target">
						<li data-toolbar="new-trip">
							<span class="material-symbols-outlined">
								draft
							</span>
							<span>New</span>
						</li>
						<li class="border-bottom" data-toolbar="duplicate" data-media="false">
							<span class="material-symbols-outlined">
								file_copy
							</span>
							<span>Duplicate</span>
							
						</li>
						<li data-toolbar="user-manager">
							<span class="material-symbols-outlined">
								person_add
							</span>
							<span>Invite Users</span>
						</li>
						<li class="border-bottom" data-toolbar="invite-access">
							<span class="material-symbols-outlined">
								key_vertical
							</span>
							<span>Invited Access</span>
						</li>
						<li data-toolbar="save">
							<span class="material-symbols-outlined">
								save
							</span>
							<span>Save</span>
						</li>
						<li data-toolbar="save-exit">
							<span class="material-symbols-outlined">
								exit_to_app
							</span>
							<span>Save and Exit</span>
						</li>
						<li data-toolbar="save-publish">
							<span class="material-symbols-outlined">
								arrow_upload_ready
							</span>
							<span>Save and Publish</span>
						</li>
					</ul>
				</li>
				<li class="tb_full">
					<span class="trip_toolbar--trigger active_listener">Edit</span>
					
					<ul class="trip_toolbar--sub active_target">
						<li data-toolbar="trip-manager">
							<span class="material-symbols-outlined">
								star
							</span>
							<span>Featured Content</span>
						</li>
						<li data-toolbar="trip-attributes">
							<span class="material-symbols-outlined">
								settings
							</span>
							<span>Itinerary Attributes</span>
						</li>
						<li data-toolbar="media-gallery">
							<span class="material-symbols-outlined">
								media_link
							</span>
							<span>Media Gallery</span>
						</li>
						<li data-toolbar="expenses">
							<span class="material-symbols-outlined">
								attach_money
							</span>
							<span>Expenses</span>
						</li>
						<li data-toolbar="organize-trip">
							<span class="material-symbols-outlined">
								article_shortcut
							</span>
							<span>Organize Trip</span>
						</li>
					</ul>
				</li>
				<li>
					<span class="trip_toolbar--trigger active_listener">View</span>
					
					<ul class="trip_toolbar--sub active_target">
						<li class="has_sub" data-toolbar="content-filter">
							<span class="material-symbols-outlined">
								filter_list
							</span>
							<span>Content Filter</span>
							<span class="toolbar_additional_options material-symbols-outlined">
								arrow_right
							</span>
							
							<ul class="trip_toolbar--sub">
								<li data-toolbar="content-filter" data-filter="all">All</li>
								<li data-toolbar="content-filter" data-filter="event">Events</li>
								<li data-toolbar="content-filter" data-filter="text">Text</li>
								<li data-toolbar="content-filter" data-filter="media">Media</li>
							</ul>
						</li>
						<li class="has_sub" data-toolbar="set-view">
							<span class="trip_manager--open material-symbols-outlined">
								edit
							</span>
							<span>Edit Mode</span>
							<span class="toolbar_additional_options material-symbols-outlined">
								arrow_right
							</span>
							
							<ul class="trip_toolbar--sub">
								<li data-toolbar="set-view" data-view="summary">Summary</li>
								<li data-toolbar="set-view" data-view="read-only">Read Only</li>
								<li data-toolbar="set-view" data-view="author">Author</li>
								<li data-toolbar="set-view" data-view="full-edit">Full Edit</li>
								<li data-toolbar="set-view" data-view="publish">Publish</li>
							</ul>
						</li>
					</ul>
				</li>
				<li class="tb_full">
					<span class="trip_toolbar--trigger active_listener">Tools</span>
					
					<ul class="trip_toolbar--sub active_target">
						<li data-toolbar="details-summary">
							<span class="material-symbols-outlined">
								text_snippet
							</span>
							<span>Details Summary</span>
						</li>
					</ul>
				</li>
				<li>
					<span class="trip_toolbar--trigger active_listener">Help</span>
					
					<ul class="trip_toolbar--sub active_target">
						<li data-toolbar="bug-report">
							<span class="material-symbols-outlined">
								bug_report
							</span>
							<span>Bug Report</span>
						</li>
						<li data-toolbar="">
							<span class="material-symbols-outlined">
								developer_guide
							</span>
							<span>Editor Guides</span>
						</li>
						<li data-toolbar="jaxbend-youtube">
							<span class="material-symbols-outlined">
								video_library
							</span>
							<span>Jaxbend YouTube</span>
						</li>
						<li data-toolbar="">
							<span class="material-symbols-outlined">
								live_help
							</span>
							<span>FAQs</span>
						</li>
					</ul>
				</li>
			</ul>
			<div class="quick_expense expense_add--open">
				<span class="material-symbols-outlined">add</span>
				<span>Expense</span>
			</div>
			<div class="trip__quick_options">
				<div class="trip__filter trip_dropdown_selector">
					<span class="material-symbols-outlined">filter_list</span>
					<div class="trip__filter_mode trip_dropdown_selector--main">
						<ul class="trip__filter_options trip_dropdown_selector--options">
							<li class="active" data-filter="all">All</li>
							<li data-filter="event">Events</li>
							<li data-filter="text">Text</li>
							<li data-filter="media">Media</li>
						</ul>
						<span class="material-symbols-outlined">arrow_drop_down</span>
					</div>
				</div>
				<div class="trip__display trip_dropdown_selector">
					<span class="material-symbols-outlined">edit</span>
					<div class="trip__display_mode trip_dropdown_selector--main">
						<ul class="trip__display_options trip_dropdown_selector--options">
							
						</ul>
						<span class="material-symbols-outlined">arrow_drop_down</span>
					</div>
				</div>
			</div>
		`;
		this.response = `<div class="response"></div>`;
		
		
		this.additional_settings = `
			<div id="trip_settings">
				<ul>
					<li>
						
						<button id="trip_save" class="bg--primary material-symbols-outlined">
							save
						</button> 
						
					</li>
				</ul>
			</div>
		`;
		
		
		$('body').on('click', '.user_manager--close', {obj: this}, function(e){
			e.preventDefault();
			
			$('#user_manager').fadeOut(200);
		})
		
		$('body').on('click', '.user_list li', {obj: this}, function(e){
			e.preventDefault();
			
			e.data.obj.remove_shared_user($(this));
		})
		
		$('body').on('click', '#publish_trip', {obj: this}, function(e){
			e.preventDefault();
			
			let $form = $('.form.trip__body');
			$form.attr('action', '/api/trip/publish');
			
			$form.submit();
		});
		
		$('body').on('click', '.trip_toolbar--sub li', {obj: this}, function(e){
			e.preventDefault();
			e.stopPropagation();
			
			e.data.obj.action($(this).attr('data-toolbar'), $(this));
		})
		
		$('body').on('click', '#mobile_toolbar_trigger', {obj: this}, function(e){
			e.preventDefault();
			e.stopPropagation();
			
			$('.trip_toolbar--main').toggle();
		})
		
	}
	
	
	async save(){
		start_loading('Saving');
		//save the trip
		let data = new FormData();
		let action = $('.form.trip__body').attr('action');
		let f = document.querySelector('.form.trip__body');
		let update_form = new FormData(f);
		let update_response = await api(action, update_form);
		
		if(update_response.error){
			end_loading('Error, See Trip');
			$('.trip__body').html('<h3 style="text-align:center">'+response.message.join('<br/>')+'</h3>');
			$('.trip__display').remove();
		}else{
			//refresh the trip data
			data.append('slug', this.slug);
			data.append('secure', false);
			let response = await api('/api/trip/read', data);
			
			//TRIP
			if(response.error){
				end_loading('Error, See Trip');
				$('.trip__body').html('<h3 style="text-align:center">'+response.message.join('<br/>')+'</h3>');
				$('.trip__display').remove();
			}else{
				end_loading('Complete');
				this.set(response.data, false);
			}
		}
	}
	
	async action(action = '', $target){
		//toolbar handler, sort the action to the correct systems
		
		switch(action){
			case 'new-trip':
				window.location.href = "/t/create";
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'save':
				this.save();
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'duplicate':
				if($target.attr('data-media') != '' && typeof($target.attr('data-media')) != 'undefined'){
					start_loading('Duplicating Trip...');
					
					let duplicate_form = new FormData();
					duplicate_form.append('trip_id', $('#trip_id').val());
					
					if($target.attr('data-media') == 'true'){
						duplicate_form.append('media', true);
					}else{
						duplicate_form.append('media', false);
					}
					
					let response = await api('/api/trip/duplicate', duplicate_form);
					console.log(response);
					if(response){
						end_loading('Redirecting');	
					}
					//took action, close toolbar
					//this.close_trip_toolbar();
				}
				break;
			case 'download-pdf':
				//took action, close toolbar
				window.open(window.location.href+'/download-pdf', "_blank");
				break;
			case 'save':
				this.save();
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'save-exit':
				this.save();
				window.location.href = "/u/trips";
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'save-publish':
				this.save();
				this.render_view('publish');
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'set-view':
				if($target.attr('data-view') != '' && typeof($target.attr('data-view')) != 'undefined'){
					this.render_view($target.attr('data-view'));
					//took action, close toolbar
					this.close_trip_toolbar();
				}
				break;
			case 'user-manager':
				$('#user_manager').css("display", "flex").hide().fadeIn(200);
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'invite-access':
				$('#lightbox_confirm').css("display", "flex").hide().fadeIn(200);
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'trip-manager':
				TripManager.open();
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'trip-attributes':
				TripAttributes.open();
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'media-gallery':
				Media.open();
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'expenses':
				ExpenseManager.open();
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'organize-trip':
				TripOrganize.open();
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'content-filter':
				if($target.attr('data-filter') != '' && typeof($target.attr('data-filter')) != 'undefined'){
					this.render_filter($target.attr('data-filter'));
					//took action, close toolbar
					this.close_trip_toolbar();
				}
				break;
			case 'details-summary':
				$('#lightbox_details').css("display", "flex").hide().fadeIn(200);
				$('#lb_details__content').html(purchase_summary__element(this.content.trip));
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'bug-report':
				$('#lightbox_contact').css("display", "flex").hide().fadeIn(200);
				//took action, close toolbar
				this.close_trip_toolbar();
				break;
			case 'jaxbend-youtube':
				window.open('https://www.youtube.com/@JaxbendOfficial', '_blank');
				//took action, close toolbar
				this.close_trip_toolbar();
				break;	
			default:
				alert('Action not supported');
		}
		
		//kill any other actions.
		return false;
	}
	
	
	set(trip, render = false){
		console.log('** SETTING TRIP **');
		
		//**** SET VARS
		this.content = trip.content; 
		this.media = this.content.trip.media;
		this.views = trip.views;
		this.expenses = trip.expenses;
		this.styles = trip.styles;
		this.slug = trip.slug;
		this.target = $('.trip__body');
		this.default_date = trip.content.trip.start_date ? trip.content.trip.start_date : User.info.today_as_format;
		this.filter = 'all';
		
		this.has_toolbar = ("full-edit" in this.views.supported) ? true : false;
		this.has_read_only = ("read-only" in this.views.supported) ? true : false;
		this.has_publish = ("publish" in this.views.supported) ? true : false;
		this.is_published = (trip.status == 'published') ? true : false;
		
		//**** SET FEATURED MEDIA AND DESCRIPTION
		if(this.content.trip.featured_media != null){
			$('#form__tr').find('.trip_gallery--open').data('set', this.content.trip.featured_media);
			$('#form__tr').find('.media_id').val(this.content.trip.featured_media);
			$('#form__tr').find('figure img').attr('src', this.media.files[this.content.trip.featured_media].path);
			$('#form__tr').find('figure img').attr('alt', this.media.files[this.content.trip.featured_media].alt);
		}
		if(this.content.trip.description != null && this.content.trip.description != 'null'){
			$('#tr__form--description').text(this.content.trip.description);
		}
		
		
		if(render){
			$('#toolbar').append(this.toolbar);
			
			//**** LOAD GLOBAL HTML
			for (const [key, value] of Object.entries(this.views.supported)) {
				const is_active = (key == trip.views.default) ? 'active' : '';
				
				const $el = $('<li/>', {
					'class': is_active,
					'data-view': key,
					'text': value
				});
				
				$('.trip__display_options').append($el);
			}
			
			
			//**** LOAD MEDIA MANAGER
			Media.set_media(this.media);
			
			//**** LOAD EXPENSE MANAGER
			ExpenseManager.set_expenses(this.expenses);
			
			//set map position to this TRIP
			Map.setView([this.content.trip.focus_lat, this.content.trip.focus_lng], this.content.trip.focus_zoom, {duration: .7});
			
			//RENDER THE DISPLAY
			this.render_view(trip.views.default);
		}
		
	}
	
	render_filter(filter = 'all'){
		this.filter = filter;
		
		$('.trip__filter_mode .trip__filter_options li').removeClass('active');
		$(`.trip__filter_mode .trip__filter_options li[data-filter="${this.filter}"]`).addClass('active');
		
		this.render_view(this.view);
	}
	
	
	render_view(view = 'summary'){
		console.log('** RENDER CORE **');
		clean_map_view(); //reset the map markers
		this.view = view;
		this.has_permission = (this.view == 'full-edit' || this.view == 'author' || this.view == 'publish') ? true : false;
		this.target.html('');
		$('.add_to_cart').remove();
		$('.publish_trip').remove();
		$('.trip__display_mode .trip__display_options li').removeClass('active');
		$(`.trip__display_mode .trip__display_options li[data-view="${this.view}"]`).addClass('active');
		
		if(!this.has_toolbar && !this.has_read_only){
			$('#toolbar').remove();
		}else{
			if(this.is_published && this.has_read_only){
				$('[data-toolbar="user-manager"]').remove();
				$('[data-toolbar="invite-access"]').remove();
				$('[data-toolbar="save"]').remove();
				$('[data-toolbar="save-exit"]').remove();
				$('[data-toolbar="save-publish"]').remove();
				$('[data-toolbar="set-view"]').remove();
				$('.tb_full').remove();
				$('.quick_expense').remove();
			}
		}
		
		const $form = $('<form/>', {
			'class': 'form trip__body',
			'action': '/api/trip/update',
			'method': 'POST',
			'data-success': 'stay'
		});
		
		if(this.view == 'publish'){
			$form.attr('action', '/api/trip/publish-draft');
		}
		
		const $no_form = $('<div/>', {
			'class': 'trip__body',
		});
		
		switch(this.view){
			case 'summary':
				this.target.replaceWith($no_form);
				this.target = $no_form;
				this.view_summary();
				break;
			case 'read-only':
				this.target.replaceWith($no_form);
				this.target = $no_form;
				this.view_full(false);
				break;
			case 'author':
				this.target.replaceWith($form);
				this.target = $form;
				this.view_full(false);
				break;
			case 'full-edit':
				this.target.replaceWith($form);
				this.target = $form;
				this.view_full(true);
				trigger_text_editor();
				break;
			case 'publish':
				this.target.replaceWith($form);
				this.target = $form;
				this.view_publish();
				trigger_text_editor();
				break;
			default:
				this.view_summary();
		}
		
	}
	
	close_trip_toolbar(){
		if($('.trip_toolbar--sub').hasClass('active')){
			$('.trip_toolbar--trigger').removeClass('active');
			$('.trip_toolbar--sub').removeClass('active');
		}
	}
	
	view_summary(){
		
		console.log('****** RENDERING SUMMARY TRIP ******');
		
		let $block;
		let $element;
		let marks = {};
		let fields = {};
		let edit = false;
		let $summary_footer = '';
		
		if(can_display(User.info.id)){
			$summary_footer = $('<form/>', {
				'class': 'form add_to_cart',
				'action': '/api/checkout/add-trip-to-cart',
				'method': 'POST',
				'data-success': 'stay'
			});
			let trip_id = `<input name="trip_id" type="hidden" value="${this.content.trip.id}" />`;
			let add_to_cart = `<input name="add_to_cart" type="submit" value="Add to Cart" />`;
			
			$summary_footer.append(trip_id, add_to_cart);
		}else{
			$summary_footer = $('<div/>', {
				'class': 'form add_to_cart',
			});
			
			let add_to_cart = `<span class="small" style="display:block; margin-bottom:4px;">Cart Unavailable <br/></span><a href="/u/account" class="btn btn--secondary">LOGIN</a>`;
			$summary_footer.append(add_to_cart);
		}
		
		this.target.append(purchase_summary__element(this.content.trip));
		this.target.append(trip_title__element(this.content.trip));
		this.target.append(trip_summary__element(this.content.trip));
		
		//BUILD BLOCKS FOR TRIP
		//sort
		const sortedBlocks = Object.entries(this.content.b).sort((a, b) => a[1]['order'] - b[1]['order']);
		//display
		for (const [block_id, block] of sortedBlocks) {
			const sortedElements = Object.entries(block.e).sort((a, b) => a[1]['order'] - b[1]['order']);
			let has_element = false;
			
			//only show blocks with a public element
			for (const [el_id, el] of sortedElements) {
				if(el.public == 1){
					has_element = true;
				}
			}
			if(sortedElements.length == 0 || !has_element){
				continue;
			}
			
			$block = trip_block__element(block, false); //user has permission for the block instead of edit to default edit mode
			
			
			//BUILD ELEMENTS FOR BLOCK
			//sort and write
			for (const [el_id, el] of sortedElements) {
				//only show public elements
				if(el.public != '1' || el.public != 1){
					continue;
				}
				if(((el.type == 'image' || el.type == 'video' || el.type == "youtube") && this.filter == 'media')
					|| el.type == this.filter
					|| this.filter == 'all'){
					//do nothing
				}else{
					continue;
				}
				
				if(el.m){
					if(Object.keys(el.m).length > 0){
						for (const [m_id, m] of Object.entries(el.m)) {
							if(typeof(el.m.marker) == 'undefined'){
								if (m_id in marks) {
									this.content.b[block_id].e[el_id].m[m_id].marker = marks[m_id];
								}else{
									//register the marker and update the el we're in so we pass data correctly
									if(m.lat != undefined && m.lng != undefined){
										el.m[m_id].marker = register_marker({
											'latlng': [m.lat, m.lng]
											, 'options': {icon: icon.get_marker_display(m)}
										}, el, m_id);
									}
									
									//update the tracking and true objects, so we reference it correctly in the future
									marks[m_id] = el.m[m_id].marker;
									this.content.b[block_id].e[el_id].m[m_id].marker = el.m[m_id].marker;
								}
							}
						}
					}
				}
				
				
				if(el.id != null){
					switch(el.type){
						case 'text':
							$element = text__element(el, edit);
							break;
						case 'event':
							this.content.b[block_id].e[el_id].fields = {
								'map': (Object.keys(el.m).length > 0) ? 1 : 1
								, 'date_time': typeof(el.c.date) != 'undefined' ? 1 : 0
								, 'description': typeof(el.c.description) != 'undefined' ? 1 : 0
								, 'expenses': typeof(el.c.expenses) != 'undefined' ? 1 : 0
								, 'location_link': typeof(el.c.location_link) != 'undefined' ? 1 : 0
								, 'directions_link': typeof(el.c.directions_link) != 'undefined' ? 1 : 0
							};
							$element = event__element(el, edit);
							$('#ex_associate').append(`
								<option value="${el_id}">${el.c.name}</option>
							`);
							break;
						case 'image':
							$element = image__element(el, edit);
							break;
						case 'video':
							$element = image__element(el, edit);
							break;
						case 'youtube':
							$element = youtube__element(el, edit);
							break;
					}
					$block.append($element);
					
				}
			}
			
			
			if(this.has_permission){
				$block.append(Editor.new_elements);
				$block.append(Editor.new_block);
			}
			this.target.append($block);
		}
		
		if(!this.has_read_only){
			$('.trip_main').append($summary_footer);
		}
	}
	
	
	view_publish(){
		console.log('****** RENDERING PUBLISH TRIP ******');
		let $block;
		let $element;
		let marks = {};
		let fields = {};
		
		const $publish_footer = $('<div/>', {
			'class': 'publish_trip',
		});
		let trip_id = `<input name="id" id="trip_id" type="hidden" value="${this.content.trip.id}" />`;
		let publish = `<button class="btn btn--primary publish--open">Review &amp; Publish</button>`;
		
		if(this.has_permission){
			$publish_footer.append(publish);
			this.target.append(this.response, this.additional_settings, trip_id);
		}
		
		this.target.append(trip_title__element(this.content.trip));
		this.target.append(trip_summary__element(this.content.trip));
		this.target.append(calendar__element(this.content));
		
		//Render the Blocks and Elements
		//BUILD BLOCKS FOR TRIP
		//sort
		const sortedBlocks = Object.entries(this.content.b).sort((a, b) => a[1]['order'] - b[1]['order']);
		//display
		for (const [block_id, block] of sortedBlocks) {
			$block = trip_block__element(block, this.has_permission); //user has permission for the block instead of edit to default edit mode
			
			
			//add a header to the block to clarify publishing
			$element = $('<div/>', {
				'class': 'publish-element',
			});
			$element.append(`<p><strong>Element</strong></p>`);
			$element.append(`<p><strong>Summary</strong></p>`);
			$block.append($element);
			
			
			//BUILD ELEMENTS FOR BLOCK
			//sort and write
			const sortedElements = Object.entries(block.e).sort((a, b) => a[1]['order'] - b[1]['order']);
			for (const [el_id, el] of sortedElements) {
				
				if(((el.type == 'image' || el.type == 'video' || el.type == 'youtube') && this.filter == 'media')
					|| el.type == this.filter
					|| this.filter == 'all'){
					//do nothing
				}else{
					continue;
				}
				
				if(el.m){
					if(Object.keys(el.m).length > 0){
						for (const [m_id, m] of Object.entries(el.m)) {
							if(typeof(el.m.marker) == 'undefined'){
								if (m_id in marks) {
									this.content.b[block_id].e[el_id].m[m_id].marker = marks[m_id];
								}else{
									//register the marker and update the el we're in so we pass data correctly
									if(m.lat != undefined && m.lng != undefined){
										el.m[m_id].marker = register_marker({
											'latlng': [m.lat, m.lng]
											, 'options': {icon: icon.get_marker_display(m)}
										}, el, m_id);
									}
									
									//update the tracking and true objects, so we reference it correctly in the future
									marks[m_id] = el.m[m_id].marker;
									this.content.b[block_id].e[el_id].m[m_id].marker = el.m[m_id].marker;
								}
							}
						}
					}
				}
				
				
				if(el.id != null){
					$element = '';
					
					switch(el.type){
						case 'text':
							$element = $('<div/>', {
								'class': 'publish-element',
							});
							$element.append(`<p><strong>Text:</strong> ${strip_html(el.c.text).slice(0, 100)} ... </p>`);
							
							break;
						case 'event':
							$element = $('<div/>', {
								'class': 'publish-element',
							});
							$element.append(`<p><strong>Event:</strong> ${strip_html(el.c.name).slice(0, 100)} ... </p>`);
							break;
						case 'image':
							$element = $('<div/>', {
								'class': 'publish-element',
							});
							$element.append(`<p><strong>Image:</strong> ${strip_html(this.media.files[el.c.media_id].path).slice(0, 100)} ... </p>`);
							break;
						case 'video':
							$element = $('<div/>', {
								'class': 'publish-element',
							});
							$element.append(`<p><strong>Video</strong></p>`);
							break;
						case 'youtube':
							$element = $('<div/>', {
								'class': 'publish-element',
							});
							$element.append(`<p><strong>YouTube</strong></p>`);
							break;
					}
					
					if($element != ''){
						$element.append(`
						<div>
							<input type="hidden" name="b[${el.block_id}][e][${el.id}][public]" value="0" />
							<input type="checkbox" name="b[${el.block_id}][e][${el.id}][public]" aria-label="Show this element in summary" value="1" ${el.public == '1' || el.public == 1 ? 'checked' : ''} /> <span>Displayed</span>
						</div>
						`);
						
						$block.append($element);
					}
				}
			}
			
			
			this.target.append($block);
		}
		
		
		$('.trip_main').append($publish_footer);
		
	}
	
	
	view_full(edit){
		console.log('****** RENDERING FULL TRIP ******');
		let $block;
		let $element;
		let trip_id = `<input id="trip_id" name="id" type="hidden" value="${this.content.trip.id}" />`;
		let marks = {};
		let response = `<div class="response"></div>`;
		let fields = {};
		
		//add elements to dropdown items
		$('#ex_associate').html('');
		$('#ex_associate').append(`
			<option value="trip">General Trip</option>
		`);
			
		if(this.has_permission){
			this.target.append(this.response, this.additional_settings, trip_id);
			this.target.append(`<input name="trip_adult_count" type="hidden" value="${this.content.trip.adult_count}" />`);
			this.target.append(`<input name="trip_child_count" type="hidden" value="${this.content.trip.child_count}" />`);
			this.target.append(`<input name="trip_physical_level" type="hidden" value="${this.content.trip.physical_level}" />`);
			this.target.append(`<input name="trip_physical_flagged" type="hidden" value="${this.content.trip.physical_flagged}" />`);
			this.target.append(`<input name="trip_gear_level" type="hidden" value="${this.content.trip.gear_level}" />`);
			this.target.append(`<input name="trip_gear_flagged" type="hidden" value="${this.content.trip.gear_flagged}" />`);
			this.target.append(`<input name="trip_prep_level" type="hidden" value="${this.content.trip.prep_level}" />`);
			this.target.append(`<input name="trip_prep_flagged" type="hidden" value="${this.content.trip.prep_flagged}" />`);
			this.target.append(`<input name="trip_media_id" type="hidden" value="${this.content.trip.featured_media}" />`);
			this.target.append(`<textarea name="trip_description" hidden>${this.content.trip.description}</textarea>`);
			
			!isNaN(this.content.trip.adult_count) ? $('input[name="manage_adult_count"]').val(this.content.trip.adult_count) : 1;
			!isNaN(this.content.trip.child_count) ? $('input[name="manage_child_count"]').val(this.content.trip.child_count) : 0;
			!isNaN(this.content.trip.physical_level) ? $('input[name="manage_physical_level"]').val(this.content.trip.physical_level) : 3;
			this.content.trip.physical_flagged == 1 ? $('input[name="manage_physical_flagged"]').attr('checked', true) : $('input[name="manage_physical_flagged"]').attr('checked', false);
			!isNaN(this.content.trip.gear_level) ? $('input[name="manage_gear_level"]').val(this.content.trip.gear_level) : 3;
			this.content.trip.gear_flagged == 1 ? $('input[name="manage_gear_flagged"]').attr('checked', true) : $('input[name="manage_gear_flagged"]').attr('checked', false);
			!isNaN(this.content.trip.prep_level) ? $('input[name="manage_prep_level"]').val(this.content.trip.prep_level) : 3;
			this.content.trip.prep_flagged == 1 ? $('input[name="manage_prep_flagged"]').attr('checked', true) : $('input[name="manage_prep_flagged"]').attr('checked', false);
		}
		
		this.target.append(trip_title__element(this.content.trip, edit));
		this.target.append(trip_summary__element(this.content.trip, edit));
		this.target.append(calendar__element(this.content));
		
		//BUILD BLOCKS FOR TRIP
		//sort
		const sortedBlocks = Object.entries(this.content.b).sort((a, b) => a[1]['order'] - b[1]['order']);
		//display
		for (const [block_id, block] of sortedBlocks) {
			$block = trip_block__element(block, this.has_permission); //user has permission for the block instead of edit to default edit mode
			
			
			//BUILD ELEMENTS FOR BLOCK
			//sort and write
			const sortedElements = Object.entries(block.e).sort((a, b) => a[1]['order'] - b[1]['order']);
			for (const [el_id, el] of sortedElements) {
				
				if(((el.type == 'image' || el.type == 'video' || el.type == 'youtube') && this.filter == 'media')
					|| el.type == this.filter
					|| this.filter == 'all'){
					//do nothing
				}else{
					continue;
				}
				
				
				if(el.m){
					if(Object.keys(el.m).length > 0){
						for (const [m_id, m] of Object.entries(el.m)) {
							if(typeof(el.m.marker) == 'undefined'){
								if (m_id in marks) {
									this.content.b[block_id].e[el_id].m[m_id].marker = marks[m_id];
								}else{
									//register the marker and update the el we're in so we pass data correctly
									if(m.lat != undefined && m.lng != undefined){
										el.m[m_id].marker = register_marker({
											'latlng': [m.lat, m.lng]
											, 'options': {icon: icon.get_marker_display(m)}
										}, el, m_id);
									}
									
									//update the tracking and true objects, so we reference it correctly in the future
									marks[m_id] = el.m[m_id].marker;
									this.content.b[block_id].e[el_id].m[m_id].marker = el.m[m_id].marker;
								}
							}
						}
					}
				}
				
				
				if(el.id != null){
					switch(el.type){
						case 'text':
							$element = text__element(el, edit);
							break;
						case 'event':
							this.content.b[block_id].e[el_id].fields = {
								'map': (Object.keys(el.m).length > 0) ? 1 : 1
								, 'date_time': typeof(el.c.date) != 'undefined' ? 1 : 0
								, 'description': typeof(el.c.description) != 'undefined' ? 1 : 0
								, 'expenses': typeof(el.c.expenses) != 'undefined' ? 1 : 0
								, 'location_link': typeof(el.c.location_link) != 'undefined' ? 1 : 0
								, 'directions_link': typeof(el.c.directions_link) != 'undefined' ? 1 : 0
							};
							$element = event__element(el, edit);
							$('#ex_associate').append(`
								<option value="${el_id}">${el.c.name}</option>
							`);
							break;
						case 'image':
							$element = image__element(el, edit);
							break;
						case 'video':
							$element = image__element(el, edit);
							break;
						case 'youtube':
							$element = youtube__element(el, edit);
							break;
					}
					$block.append($element);
					
				}
			}
			
			
			if(this.has_permission){
				$block.append(Editor.new_elements);
				$block.append(Editor.new_block);
			}
			this.target.append($block);
		}
		
		if(this.view == 'author'){
			Editor.render();
		}
	}
	
	
	
	switch_element(el_id, block_id, edit = false){
		console.log('** SWITCH BLOCK **');
		
		let data = {};
		let $content = '';
		
		//unique trip elements
		if(block_id == 'trip'){
			data = this.content.trip;
			
			if(el_id == 'name'){
				$content = trip_title__element(data, edit);
			}
			if(el_id == 'summary'){
				$content = trip_summary__element(data, edit);
			}
			
		//stardard block & element system
		}else{
			data = this.content.b[block_id].e[el_id];
			switch(data.type){
				
				case 'text':
					$content = text__element(data, edit);
					break;
				case 'event':
					$content = event__element(data, edit);
					break;
				case 'image':
					$content = image__element(data, edit);
					break;
				case 'video':
					$content = image__element(data, edit);
					break;
				case 'youtube':
					$content = youtube__element(data, edit);
					break;
			}
		}
		
		//if in an 'edit' mode add the switcher elements onto this so we can manage it
		if(edit){
			if(block_id == 'trip'){
				$content.append(Editor.trip_options);
			}else{
				$content.append(Editor.active_options);
			}
		}else{
			$content.append(Editor.inactive_options);
		}
		$(`[data-el_id="${el_id}"][data-block_id="${block_id}"]`).replaceWith($content);
		
		
		//with content loaded, trigger editor in case we're in full edit
		if(edit){
			trigger_text_editor();
			
			$('.btn--marker').each(function(index){
				if(Number.isInteger(Number($(this).attr('data-marker'))) && $(this).attr('data-marker') != ''){
					set_button_state($(this), 'update');
				}
			});
		}
	}
	
	
	
	//user manager
	async remove_shared_user($target){
		//create the form to upload a file
		let user_form = new FormData();
		let user_email = $target.text();
		let trip_id = $('#invite_trip_id').val();
		
		user_form.append('uninvite_email', user_email);
		user_form.append('trip_id', trip_id);
		
		try {
			let response = await fetch('/api/user/trip-uninvite', {
				method: 'POST',
				body: user_form
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			let result = await response.json();
			
			if(result.error){
				alert('An unexpected error occurred. Please refresh and try again.');
			}else{
				$target.remove();
			}
			
		} catch (error) {
			console.error('Error ***', error);
		}
	}
}